export default {"src":"/_next/static/media/servicesIcon.98df748a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};